const styles = {
  skeleton: { bgcolor: 'neutral.50' },
};

export default styles;
